import { get } from 'lodash';

export const getData = obj => get(obj, 'data');



// WEBPACK FOOTER //
// ./src/utils/get.js